<template>
  <div class="container-md">
    <div class="row justify-content-center body">
      <div class="col-auto px-5">
        <div class="py-3 text-center">
          <h3>{{ $t("reset.title") }}</h3>
        </div>
        <form class="border bg-light p-3" @submit.prevent="submit" novalidate>
          <div class="text-center">
            <p v-html="$t('reset.message')" class="text-muted"></p>
          </div>
          <div class="p-2">
            <input type="password" class="form-control" id="password" v-model="inputPassword" @blur="validatePassword" :placeholder="$t('common.password')">
            <p class="text-danger mb-0" v-show="isPasswordError">{{ $t("signUp.passwordError") }}</p>
          </div>
          <div class="p-2">
            <input type="password" class="form-control" id="passwordConfirm" v-model="inputPasswordConfirm" @blur="collatePassword" :placeholder="$t('signUp.passwordConfirm')">
            <p class="text-danger mb-0" v-show="isPasswordConfirmError">{{ $t("signUp.passwordConfirmError") }}</p>
          </div>
          <div class="d-grid gap-2 p-2 mt-2">
            <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled">{{ $t("reset.reset") }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Const from '../const.js'
import axios from 'axios'
import reCaptchaMixin from "../mixins/reCaptchaMixin";

export default {
  mixins: [reCaptchaMixin],
  data() {
    return {
      inputPassword: "",
      inputPasswordConfirm: "",
      isPasswordError: false,
      isPasswordConfirmError: false,
      isButtonDisabled: false
    }
  },

  methods: {
    async submit() {
      this.isButtonDisabled = true
      this.isPasswordError = false
      this.isPasswordConfirmError = false
      this.validatePassword()
      this.collatePassword()

      if (this.isPasswordError || this.isPasswordConfirmError) {
        this.isButtonDisabled = false
        return
      }

       // reCaptchaからトークンを取得
      let recaptchaToken = ""
      try{
        recaptchaToken = await this.getRecaptchaToken()
      }catch(error){
        this.postResult = "error"
        this.isButtonDisabled = false
      }

      try{
        const headers = {
              "Authorization": this.$route.query.token,
              "Content-Type": "application/json"
            }
        const body = {
          password: this.inputPassword,
          recaptcha_token: recaptchaToken
        }
        const response = await axios.post(Const.BASE_URL + "/password-update", body , {headers})

        console.log(response)
        this.$router.push({ name: "resetResult" })

      }catch(error){
        console.log(error)
        this.isButtonDisabled = false
      }
    },

    validatePassword() {
      const regexp = new RegExp(Const.REGEXP_FOR_PASSWORD)
      
      if (!this.inputPassword || !regexp.test(this.inputPassword)) {
        this.isPasswordError = true
      } else {
        this.isPasswordError = false
      }
    },

    collatePassword() {
      if (this.inputPassword !== this.inputPasswordConfirm) {
        this.isPasswordConfirmError = true
      } else {
        this.isPasswordConfirmError = false
      }
    },
  },

  created() {
    axios.post(Const.BASE_URL + "/authentication-email", "", {
      headers: {
        "Authorization": this.$route.query.token,
        "Content-Type": "application/json"
        }
    })
    .then(function() {
      // console.log(response)
    }.bind(this))
    .catch(function() {
      // console.log(error)
      this.$store.dispatch("updateTokenError", true)
      this.$router.push({ name: "login" })
    }.bind(this))
  },
}
</script>

<style scoped>
.body {
  height: 100%;
  padding-top:128px;
}
</style>
